<template>
  <nav class="Mine__menu menu-text-visible" ref="lnb">
    <ui-logo />
    <div class="Mine__menu-content">
      <ul class="nav-list">
        <li class="nav-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.47917 0.8125C10.9749 0.8125 12.1875 2.02506 12.1875 3.52083V9.47917C12.1875 10.9749 10.9749 12.1875 9.47917 12.1875H3.52083C2.02506 12.1875 0.8125 10.9749 0.8125 9.47917V3.52083C0.8125 2.02506 2.02506 0.8125 3.52083 0.8125H9.47917ZM3.52083 1.89583C2.62337 1.89583 1.89583 2.62337 1.89583 3.52083V9.47917C1.89583 10.3766 2.62337 11.1042 3.52083 11.1042H4.875V1.89583H3.52083ZM5.95833 7.04167V11.1042H9.47917C10.3766 11.1042 11.1042 10.3766 11.1042 9.47917V7.04167H5.95833ZM5.95833 5.95833H11.1042V3.52083C11.1042 2.62337 10.3766 1.89583 9.47917 1.89583H5.95833V5.95833Z" fill="#999999"/>
          </svg>
          <router-link to="/dashboard">
            Dashboard
          </router-link>
        </li>
      </ul>
    </div>
    <mine-panel/>
  </nav>
</template>
<script>
import UiLogo from '@/components/ui/UiLogo.vue'
import MinePanel from '@/components/mine/MinePanel.vue'

export default {
  name: 'MineMenu',
  components: { MinePanel, UiLogo }
}
</script>

<style scoped lang="scss">
.Mine__menu {
  max-height: 100vh;
  height: 100%;
  max-width: 210px;
  width: 100%;
  background: #1B1B1D;

  .nav {
    &-list {
      border-bottom: 1px solid #666;
      padding: 0 12px 10px;
      margin-top: 35px;
    }

    &-item {
      color: #999;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 6px;
      height: 26px;
      padding: 0 4px;

      &:hover {
        color: #fff;
        svg {
          path {
            fill: #fff;
          }
        }
      }

      a {
        color: inherit;
        font: inherit;
        line-height: 26px;
      }
    }
  }
}
</style>
